module.exports = __webpack_public_path__ + "img/total.1a42cc53.png";